import { useCallback } from "react";
import { IS_PROD } from "domains/commons/environment";
import usePersistedState, {
  PersistedStateKey,
} from "domains/commons/hooks/usePersistedState";

export const DEFAULT_MODEL_IDS = {
  image: "flux.1-pro",
  texture: IS_PROD
    ? "model_y9RATUheDpFyXMnbKSXoEMEi" // Texture Realistic V2 for Production
    : "stable-diffusion-xl-base-1.0",
  "3d": IS_PROD ? "model_hunyuan-3d-v2-1" : "model_staging_hunyuan-3d-v2-1",
  video: IS_PROD ? "model_kling-v2-0" : "model_staging_kling-v2-0",
  "video-upscale": IS_PROD
    ? "model_topazlabs-video-upscale"
    : "model_staging_topazlabs-video-upscale",
};

export default function useLastModelId(
  type: "image" | "texture" | "3d" | "video" | "video-upscale"
): [string, (id: string) => void] {
  const [lastModelIds, setLastModelIds] = usePersistedState(
    PersistedStateKey.LAST_MODEL_ID,
    {
      defaultValue: DEFAULT_MODEL_IDS,
    }
  );

  const lastModelId = lastModelIds[type] ?? DEFAULT_MODEL_IDS[type];
  const setLastModelId = useCallback(
    (id: string) => {
      setLastModelIds((lastModelIds) => ({ ...lastModelIds, [type]: id }));
    },
    [type, setLastModelIds]
  );

  return [lastModelId, setLastModelId];
}
